<template>
    <Row type="none" class="bg-white rounded shadow">

        <OrderItemListTable class="pt-4" />

        <div class="container row mt-4">
            <div class="col-12">
                <div v-if="getOrder.autoOrderItems.length" class="subtitle">
                    {{ $t('product.count') }}: <span class="subtitle_result">{{ numberWithCommas(getOrder.autoOrderItems.length) }}</span>
                </div>
                <div class="subtitle mt-1">
                    {{ $t('autoOrder.productPriceSum') }}: <span class="subtitle_result">{{ showCurrencyById(3, getOrder.sum) }}</span>
                </div>
            </div>
        </div>

        <div class="container row pb-4">
                <div class="col-12 col-md-6 col-xl-4 mt-4">
                    <SubmitRow
                        v-if="!getOrder.isOrdered"
                        text="autoOrder.makeOrder"
                        sm-size="12"
                        md-size="12"
                        :is-disabled="false"
                        :do-action="makeOrder"
                        :is-loading="isLoading"
                    />
                    <SubmitRow
                        v-if="getOrder.isOrdered"
                        text="autoOrder.ordered"
                        sm-size="12"
                        md-size="12"
                        :is-disabled="true"
                        :do-action="makeOrder"
                        :is-loading="isLoading"
                    />
                </div>
                <div v-if="getOrder.isOrdered" class="col-12 col-md-6 col-xl-4 offset-xl-4 pr-0">
                    <span style="color: #7E7E7E; font-size: 14px">{{ $t('autoOrder.excelFileForPurchase') }}</span>
                    <vue-excel-xlsx
                        class="btn btn-success w-100"
                        @click.native="makePurchaseXlsFile"
                        :data="filePurchaseXls"
                        :columns="columns"
                        :file-type="'xlsx'"
                        file-name="for_purchase"
                        sheet-name="for_purchase"
                    >
                        {{ $t('download') }}
                    </vue-excel-xlsx>
                </div>
        </div>

    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import {mapActions, mapGetters} from "vuex";
import OrderItemListTable from "@/components/OrderItemListTable.vue";
import SubmitRow from "@/components/SubmitRow.vue";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import {exportFile} from "@/store/local/exportFile";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
Vue.use(VueExcelXlsx)

export default {
    name: "AutoOrderItem",
    components: {OrderItemListTable, Row, SubmitRow},
    mixins: [currencyFormatMixin],
    data() {
        return {
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'autoOrder.title', url: 'orders'},
            ],
            orderForm: {
                isOrdered: true,
                orderId: null,
            },
            data: [],
            columns: [
                {
                    label: this.$t('product.title'),
                    field: this.$t('product.title')
                },
                {
                    label: this.$t('amount'),
                    field: this.$t('amount')
                },
                {
                    label: this.$t('warehouse.title'),
                    field: this.$t('warehouse.title')
                },
                {
                    label: this.$t('supplier.title'),
                    field: this.$t('supplier.title')
                },
                {
                    label: this.$t('sellingPrice'),
                    field: this.$t('sellingPrice')
                },
                {
                    label: this.$t('excel.saleCurrency'),
                    field: this.$t('excel.saleCurrency')
                },
                {
                    label: this.$t('boughtPrice'),
                    field: this.$t('boughtPrice')
                },
                {
                    label: this.$t('excel.purchaseCurrency'),
                    field: this.$t('excel.purchaseCurrency')
                },
                {
                    label: this.$t('unitOfMeasure.unitOfMeasure'),
                    field: this.$t('unitOfMeasure.unitOfMeasure')
                },
            ],
            fileXls: [],
            filePurchaseXls: [],
            fileName: null
        }
    },
    computed: {
        ...mapGetters(['getOrder', 'getOrders', 'getWarehouses'])
    },
    methods: {
        ...mapActions(['putOrder','fetchOrders', 'fetchOrder', 'fetchWarehousesSearch', 'setBreadcrumbItems']),
        makeOrder() {
            this.$root.showOverlay = true
            this.putOrder(this.orderForm)
                .then(() => {
                    this.makeExport()
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        makeXlsFile() {
            for (let orderItem of this.getOrder.autoOrderItems) {
                let row = {}
                row[this.$t('product.name')] = orderItem.product.name
                row[this.$t('warehouse.remainder')] = orderItem.residue
                row[this.$t('autoOrder.order')] = orderItem.orderAmount
                row[this.$t('autoOrder.saleRate')] = orderItem.sold
                row[this.$t('autoOrder.avgSaleRate')] = orderItem.averageSaleRate
                row[this.$t('supplier.title')] = this.getSupplierName(orderItem)

                this.fileXls.push(row)
            }
        },
        makePurchaseXlsFile() {
            for (let orderItem of this.getOrder.autoOrderItems) {
                let row = {}
                row[this.$t('product.title')] = orderItem.product.name
                row[this.$t('amount')] = parseFloat(orderItem.orderAmount)
                row[this.$t('warehouse.title')] = orderItem.warehouse.name
                row[this.$t('supplier.title')] = this.getSupplierName(orderItem)
                row[this.$t('sellingPrice')] = parseFloat(orderItem.product.sellingPrice)
                row[this.$t('excel.saleCurrency')] = orderItem.product.sellingPriceCurrency.shortName
                row[this.$t('boughtPrice')] = parseFloat(orderItem.purchasePrice)
                row[this.$t('excel.purchaseCurrency')] = orderItem.purchaseCurrency.shortName
                row[this.$t('unitOfMeasure.unitOfMeasure')] = this.changeValueUnitOfMeasure(orderItem.product.unitOfMeasure)

                this.filePurchaseXls.push(row)
            }
        },
        exportData() {
            exportFile().exportDataFromJSON(this.fileXls, this.fileName, 'xls')
        },
        async makeExport() {
            await this.sortBySupplier()
            await this.makeXlsFile()
            await this.exportData()
            await this.makePurchaseXlsFile()

            this.$root.showOverlay = false
        },
        sortBySupplier() {
            this.getOrder.autoOrderItems.sort(function (a, b) {
                return a.supplier.id - b.supplier.id
            })
        },
        getSupplierName(item) {
            return item.supplier.isCompany ?
                item.supplier.supplierCompany.name :
                item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        changeValueUnitOfMeasure(unitOfMeasure) {
            switch (unitOfMeasure) {
                case 'pc' :
                    return this.$t("unitOfMeasure.pc")
                case 'g' :
                    return this.$t("unitOfMeasure.g")
                case 'kg' :
                    return this.$t("unitOfMeasure.kg")
                case 'ml' :
                    return this.$t("unitOfMeasure.ml")
                case 'l' :
                    return this.$t("unitOfMeasure.l")
                case 'mm' :
                    return this.$t("unitOfMeasure.mm")
                case 'cm' :
                    return this.$t("unitOfMeasure.cm")
                case 'm' :
                    return this.$t("unitOfMeasure.m")
                case 'km' :
                    return this.$t("unitOfMeasure.km")
                case 'ft' :
                    return this.$t("unitOfMeasure.ft")
                case 'm3' :
                    return this.$t("unitOfMeasure.m3")
                default:
                    return unitOfMeasure
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this.orderForm.orderId = this.$route.params.id

        if (this.getOrder.autoOrderItems === undefined) {
            this.fetchOrder(this.$route.params.id)
                .then(() => {
                    if (this.filePurchaseXls.length === 0) {
                        this.makePurchaseXlsFile()
                    }
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        }
    }
}
</script>

<style scoped>
.subtitle {
    color: #7E7E7E;
}

.subtitle_result {
    color: #444444;
    font-weight: 600;
}
</style>
